import { Relationships } from '@leverege/molten/data-source';
import RootDeviceGroup from "./RootDeviceGroup.js";
import RootDeviceType from "./RootDeviceType.js";
import RootFirmwareRelease from "./RootFirmwareRelease.js";
import RootFirmwareApplication from "./RootFirmwareApplication.js";
import RootFirmwareComponent from "./RootFirmwareComponent.js";
import RootDevice from "./RootDevice.js";
function install(molten) {
  Relationships.add(RootDeviceType(molten));
  Relationships.add(RootDeviceGroup(molten));
  Relationships.add(RootFirmwareRelease(molten));
  Relationships.add(RootFirmwareApplication(molten));
  Relationships.add(RootFirmwareComponent(molten));
  Relationships.add(RootDevice(molten));
}
export { install };
export default {
  install
};